import { createTheme } from '@material-ui/core/styles';

const theme = (primaryThemeColor, primaryThemeFontColor, primaryFontFamily, secondaryFontFamily, backgroundThemeColor) => {
  return createTheme({
    typography: {
      body: {
        fontFamily: secondaryFontFamily,
        fontStyle: 'normal',
        fontSize: '14px',
      },
      body1: {
        fontFamily: secondaryFontFamily,
        fontStyle: 'normal',
        fontSize: '14px',
      },
      body2: {
        fontFamily: secondaryFontFamily,
        fontStyle: 'normal',
        fontSize: '14px',
      },
      body3: {
        fontFamily: secondaryFontFamily,
        fontStyle: 'normal',
        fontSize: '14px',
      },
      h1: {
        fontFamily: primaryFontFamily,
      },
      h2: {
        fontFamily: primaryFontFamily,
      },
      h3: {
        fontFamily: primaryFontFamily,
      },
      h4: {
        fontFamily: primaryFontFamily,
      },
      h5: {
        fontFamily: primaryFontFamily,
      },
      h6: {
        fontFamily: primaryFontFamily,
      },
    },
    overrides: {
      MuiAppBar: {
        colorPrimary: {
          color: primaryThemeColor.trim()
        }
      },
      MuiTab: {
        root: {
          maxWidth: '270px',
          fontFamily: primaryFontFamily,
        }
      },
      MuiCssBaseline: {
        '@global': {
          '.Mui-disabled': { background: 'rgba(0,0,0,0.08)'},
          '@font-face': [
            {
              fontFamily: secondaryFontFamily,
              fontStyle: 'normal',
            },
          ],
        },
      },
      MuiFormLabel: {
        root: {
          color: 'rgba(0, 0, 0, 0.74)',
          '&$disabled': {
            color: 'rgba(0, 0, 0, 0.50)',
          },
        },
      },
      MuiInputBase: {
        root: {
          '&$disabled': {
            color: 'rgba(0, 0, 0, 0.50)',
          },
          [`& fieldset`]: {
            borderRadius: '25px',
          },
        },
      },
      MuiTableCell: {
        head: {
          color: 'rgba(0, 0, 0, 0.87)',
          fontWeight: '550',
          textTransform: 'capitalize',
          fontFamily: primaryFontFamily,
        },
        root: {
          padding: '4px 8px 4px 8px !important'
        }
      },
      MuiPickersToolbar: {
        toolbar: {
          height: '70px',
        },
      },
      MuiTypography: {
        subtitle1: {
          fontSize: '.85rem',
        },
        h4: {
          fontSize: '1.125rem',
        },
        h6: {
          textTransform: 'capitalize'
        },
      },
      MuiTooltip: {
        tooltip: {
          fontSize: '0.900rem',
          maxWidth: '400px',
          backgroundColor: 'rgba(40, 40, 40, 0.9)',
        },
      },
      MuiIconButton: {
        colorInherit: {
          color: primaryThemeFontColor.trim(),
        },
      },
      MuiButton: {
        containedPrimary: {
          color: primaryThemeFontColor.trim(),
        },
        root: {
          borderRadius: '20px',
          padding: '10px 30px',
          minWidth: '155px',
        },
        outlined: {
          '&$disabled': {
            color: 'rgba(0, 0, 0, 0.50)',
            border: '1px solid rgba(0, 0, 0, 0.26)',
          },
        },
        contained: {
          boxShadow: 'none',
        },
      },
      MuiSkeleton: {
        root: {
          backgroundColor: 'rgba(0, 0, 0, 0.13)'
        }
      },
      MuiFormHelperText: {
        root: {
          fontFamily: secondaryFontFamily,
        },
      },
      MuiAutocomplete: {
        option: {
          paddingTop: '3px',
          paddingBottom: '3px',
        },
      },
    },
    palette: {
      primary: {
        main: primaryThemeColor.trim(),
      },
      background: {
        default: backgroundThemeColor,
      },
      success : {
        main : primaryThemeColor.trim(),
      },
      white: {
        main: '#fff',
      }
    },
  });
};

export default theme;
